import { createFileRoute } from "@tanstack/react-router";
import AcceptableUse from "@/pages/AcceptableUse";
export const Route = createFileRoute("/acceptable-use")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Acceptable Use Policy | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Read the Acceptable Use Policy for Neuro Wellness TMS Centers of America. Learn the rules and guidelines governing the responsible use of our products and.",
        },
        {
          property: "og:title",
          content: "Acceptable Use Policy | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Read the Acceptable Use Policy for Neuro Wellness TMS Centers of America. Learn the rules and guidelines governing the responsible use of our products and.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/acceptable-use",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/acceptable-use",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AcceptableUse />;
}
